<template>
	<div class="list-todo-dashboard cbs-custom-table pb-3">
		<div class="header">
			<h4 class="header__title pt-6 pl-6">{{ $t("MyTodoList") }}</h4>
		</div>

		<todo-list-management :isQuickMode="true" class="p-6" />
	</div>
</template>

<script>
import TodoListManagement from "@/views/apps/cbs/todo-list/TodoListManagement";

export default {
	name: "ListTodoAssignedToMe",
	components: {
		TodoListManagement
	}
};
</script>
